import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const LICENSE_USAGE_LOGS_LICENSE_USAGE_LOG_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/license-usage-logs',
        iconClass: 'fas fa-user-clock',
        name: '::Menu:LicenseUsageLogs',
        layout: eLayoutType.application,
        requiredPolicy: 'Ldm.LicenseUsageLogs',
      },
    ]);
  };
}
